import style from "./style.scss";

const ratingTemplate = document.createElement("template");
ratingTemplate.innerHTML = /* html */ `
  <style>
    ${style}
  </style>
  <div class="content">
    <span id="close" class="close">
      x
    </span>
    <p class="mt-auto mb-0 text-center">Tell us what you think of <span id="websiteName"></span>?</p>
    <form id="form" class="mb-auto">
      <div id="ratings" class="rating" aria-labelledby="rating">
        <input type="radio" id="star5" name="rating" value="5" />
        <label for="star5" title="5 stars">
          5 stars
        </label>
        <input type="radio" id="star4" name="rating" value="4" />
        <label for="star4" title="4 stars">
          4 stars
        </label>
        <input type="radio" id="star3" name="rating" value="3" />
        <label for="star3" title="3 stars">
          3 stars
        </label>
        <input type="radio" id="star2" name="rating" value="2" />
        <label for="star2" title="2 stars">
          2 stars
        </label>
        <input type="radio" id="star1" name="rating" value="1" />
        <label for="star1" title="1 star">
          1 star
        </label>
      </div>
    </form>
  </div>
`;

export { ratingTemplate };
